// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * The following are shared across all platforms and apps
 */
.access-page {
  box-sizing: border-box;
  max-width: 1080px;
  margin: 0 auto;
  padding: 1.5rem 1.25rem 2.5rem;
  color: var(--undp-jtf-primary-color, #003770);
  font-family: "OpenSans-Regular";
}

.access-page__header {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #d7e0eb;
}

.access-page__title {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.3;
  color: var(--undp-jtf-primary-color, #003770);
}

.access-page__lead {
  margin: 0;
  max-width: 36rem;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #5c6570;
}

.access-layout {
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr);
  gap: 1.5rem;
  align-items: start;
}

.access-aside__label {
  margin: 0 0 0.65rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5c6570;
}

.access-aside__list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.access-role {
  width: 100%;
  margin: 0;
  padding: 0.55rem 0.75rem;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--undp-jtf-primary-color, #003770);
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.access-role:hover {
  background: #f5f7fa;
}
.access-role--active {
  background: #fff;
  border-color: #d7e0eb;
  box-shadow: inset 3px 0 0 var(--undp-jtf-btn-dark-color, #003770);
  font-weight: 600;
}
.access-role:focus-visible {
  outline: 2px solid var(--undp-jtf-btn-dark-color, #003770);
  outline-offset: 1px;
}

.access-main {
  background: #fff;
  border: 1px solid #d7e0eb;
  border-radius: 8px;
  padding: 1.25rem 1.35rem 1.5rem;
}

.access-main__top {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #d7e0eb;
}

.access-main__title {
  margin: 0 0 0.25rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--undp-jtf-primary-color, #003770);
}

.access-main__desc {
  margin: 0;
  font-size: 0.85rem;
  color: #5c6570;
  line-height: 1.4;
  max-width: 28rem;
}

.access-btn {
  min-height: 2.25rem;
  padding: 0.45rem 1.1rem;
  border: none;
  border-radius: 6px;
  background: var(--undp-jtf-btn-dark-color, #003770);
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.access-btn:hover:not(:disabled) {
  filter: brightness(1.08);
}
.access-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.access-msg {
  margin: 0 0 1rem;
  font-size: 0.85rem;
  line-height: 1.4;
}
.access-msg--ok {
  color: #166534;
}
.access-msg--err {
  color: #b91c1c;
}
.access-msg--err small {
  display: block;
  margin-top: 0.2rem;
  opacity: 0.9;
  font-size: 0.8rem;
}

.access-block {
  margin-top: 1.35rem;
}
.access-block:first-of-type {
  margin-top: 0;
}

.access-block__title {
  margin: 0 0 0.35rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5c6570;
}

.access-block__lead {
  margin: 0 0 0.55rem;
  font-size: 0.8rem;
  line-height: 1.35;
  color: #5c6570;
  max-width: 38rem;
}

.access-check-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.35rem 1rem;
}

.access-scope {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
  margin-bottom: 0.85rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #eef1f5;
}

.access-check {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 0.875rem;
  color: var(--undp-jtf-primary-color, #003770);
  cursor: pointer;
  line-height: 1.3;
}
.access-check input {
  width: 1rem;
  height: 1rem;
  margin: 0;
  flex: 0 0 auto;
  accent-color: var(--undp-jtf-btn-dark-color, #003770);
}
.access-check--form {
  font-weight: 600;
}

/* —— Form grant matrix (compact) —— */
.access-grants {
  display: flex;
  flex-direction: column;
  margin-top: 0.25rem;
  padding: 0.15rem 0.55rem;
  border: 1px solid #eef1f5;
  border-radius: 6px;
  background: #fafbfc;
}

.access-chip-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.access-chip {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.3rem;
  margin: 0;
  min-width: 6.25rem;
  padding: 0.25rem 0.5rem 0.25rem 0.35rem;
  border: 1px solid #d7e0eb;
  border-radius: 4px;
  background: #fff;
  font-size: 0.78rem;
  line-height: 1.2;
  color: var(--undp-jtf-primary-color, #003770);
  cursor: pointer;
  white-space: nowrap;
}
.access-chip input {
  width: 0.85rem;
  height: 0.85rem;
  margin: 0;
  flex: 0 0 auto;
  accent-color: var(--undp-jtf-btn-dark-color, #003770);
}
.access-chip:hover {
  border-color: #b8c5d4;
}
.access-chip--on {
  border-color: rgba(0, 55, 112, 0.35);
  background: rgba(0, 55, 112, 0.06);
  font-weight: 600;
}
.access-chip--locked {
  opacity: 0.72;
  cursor: default;
}
.access-chip--locked input {
  cursor: default;
}

.access-scope-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  min-height: 2.15rem;
  padding: 0.4rem 0;
  border-top: 1px solid #eef1f5;
}
.access-scope-row:first-child {
  border-top: none;
  padding-top: 0.2rem;
}
.access-scope-row:last-child {
  padding-bottom: 0.2rem;
}

.access-scope-row__title {
  min-width: 0;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.3;
  color: var(--undp-jtf-primary-color, #003770);
}

.access-scope-row__scopes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.35rem;
  flex: 0 0 auto;
}

.access-forms {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.access-form {
  padding: 0.4rem 0;
  border-bottom: 1px solid #eef1f5;
}
.access-form:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.access-form .access-grants {
  margin-top: 0.4rem;
}

.access-empty {
  margin: 2rem 0 0;
  text-align: center;
  color: #5c6570;
  font-size: 0.9rem;
}

@media (max-width: 720px) {
  .access-page {
    padding: 1rem 0.85rem 2rem;
  }
  .access-layout {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .access-aside__list {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .access-role {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/user-access-management/user-access/user-access.component.scss","webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;ADSA;EACE,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,6CAZI;EAaJ,+BEVqB;AFMvB;;AAOA;EACE,qBAAA;EACA,oBAAA;EACA,gCAAA;AAJF;;AAOA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6CA3BI;AAuBN;;AAOA;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAlCM;AA8BR;;AAOA;EACE,aAAA;EACA,2CAAA;EACA,WAAA;EACA,kBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAlDM;AA8CR;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,SAAA;EACA,wBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAtEI;EAuEJ,eAAA;EACA,gEAAA;AAJF;AAME;EACE,mBAvEC;AAmEL;AAOE;EACE,gBA5EM;EA6EN,qBA9EG;EA+EH,iEAAA;EACA,gBAAA;AALJ;AAQE;EACE,0DAAA;EACA,mBAAA;AANJ;;AAUA;EACE,gBAzFQ;EA0FR,yBAAA;EACA,kBAAA;EACA,+BAAA;AAPF;;AAUA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gCAAA;AAPF;;AAUA;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,6CAjHI;AA0GN;;AAUA;EACE,SAAA;EACA,kBAAA;EACA,cAtHM;EAuHN,gBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mDA5HO;EA6HP,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAPF;AASE;EACE,wBAAA;AAPJ;AAUE;EACE,YAAA;EACA,mBAAA;AARJ;;AAYA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AATF;AAWE;EACE,cAAA;AATJ;AAYE;EACE,cAAA;AAVJ;AAYI;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAVN;;AAeA;EACE,mBAAA;AAZF;AAcE;EACE,aAAA;AAZJ;;AAgBA;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cApLM;AAuKR;;AAgBA;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cA3LM;EA4LN,gBAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,4DAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,6CAxNI;EAyNJ,eAAA;EACA,gBAAA;AAbF;AAeE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,qDA5NK;AA+MT;AAgBE;EACE,gBAAA;AAdJ;;AAkBA,sCAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,uCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAlQQ;EAmQR,kBAAA;EACA,gBAAA;EACA,6CAxQI;EAyQJ,eAAA;EACA,mBAAA;AAhBF;AAkBE;EACE,cAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,qDA5QK;AA4PT;AAmBE;EACE,qBAAA;AAjBJ;AAoBE;EACE,oCAAA;EACA,kCAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,eAAA;AAnBJ;AAqBI;EACE,eAAA;AAnBN;;AAwBA;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,qBAAA;OAAA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;AArBF;AAuBE;EACE,gBAAA;EACA,mBAAA;AArBJ;AAwBE;EACE,sBAAA;AAtBJ;;AA0BA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6CAhUI;AAySN;;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,iBAAA;EACA,gCAAA;AAvBF;AAyBE;EACE,mBAAA;EACA,iBAAA;AAvBJ;AA0BE;EACE,kBAAA;AAxBJ;;AA4BA;EACE,gBAAA;EACA,kBAAA;EACA,cAhWM;EAiWN,iBAAA;AAzBF;;AA4BA;EACE;IACE,0BAAA;EAzBF;EA4BA;IACE,0BAAA;IACA,SAAA;EA1BF;EA6BA;IACE,mBAAA;IACA,eAAA;EA3BF;EA8BA;IACE,WAAA;EA5BF;AACF","sourcesContent":["@import '../../../../scss/variables';\n\n$ink: var(--undp-jtf-primary-color, #003770);\n$muted: #5c6570;\n$line: #d7e0eb;\n$surface: #fff;\n$bg: #f5f7fa;\n$active: var(--undp-jtf-btn-dark-color, #003770);\n\n.access-page {\n  box-sizing: border-box;\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 1.5rem 1.25rem 2.5rem;\n  color: $ink;\n  font-family: $primary-font-regular;\n}\n\n.access-page__header {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid $line;\n}\n\n.access-page__title {\n  margin: 0 0 0.35rem;\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.3;\n  color: $ink;\n}\n\n.access-page__lead {\n  margin: 0;\n  max-width: 36rem;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: $muted;\n}\n\n.access-layout {\n  display: grid;\n  grid-template-columns: 200px minmax(0, 1fr);\n  gap: 1.5rem;\n  align-items: start;\n}\n\n.access-aside__label {\n  margin: 0 0 0.65rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $muted;\n}\n\n.access-aside__list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.access-role {\n  width: 100%;\n  margin: 0;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: $ink;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: $bg;\n  }\n\n  &--active {\n    background: $surface;\n    border-color: $line;\n    box-shadow: inset 3px 0 0 $active;\n    font-weight: 600;\n  }\n\n  &:focus-visible {\n    outline: 2px solid $active;\n    outline-offset: 1px;\n  }\n}\n\n.access-main {\n  background: $surface;\n  border: 1px solid $line;\n  border-radius: 8px;\n  padding: 1.25rem 1.35rem 1.5rem;\n}\n\n.access-main__top {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid $line;\n}\n\n.access-main__title {\n  margin: 0 0 0.25rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: $ink;\n}\n\n.access-main__desc {\n  margin: 0;\n  font-size: 0.85rem;\n  color: $muted;\n  line-height: 1.4;\n  max-width: 28rem;\n}\n\n.access-btn {\n  min-height: 2.25rem;\n  padding: 0.45rem 1.1rem;\n  border: none;\n  border-radius: 6px;\n  background: $active;\n  color: #fff;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n\n  &:hover:not(:disabled) {\n    filter: brightness(1.08);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.access-msg {\n  margin: 0 0 1rem;\n  font-size: 0.85rem;\n  line-height: 1.4;\n\n  &--ok {\n    color: #166534;\n  }\n\n  &--err {\n    color: #b91c1c;\n\n    small {\n      display: block;\n      margin-top: 0.2rem;\n      opacity: 0.9;\n      font-size: 0.8rem;\n    }\n  }\n}\n\n.access-block {\n  margin-top: 1.35rem;\n\n  &:first-of-type {\n    margin-top: 0;\n  }\n}\n\n.access-block__title {\n  margin: 0 0 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: $muted;\n}\n\n.access-block__lead {\n  margin: 0 0 0.55rem;\n  font-size: 0.8rem;\n  line-height: 1.35;\n  color: $muted;\n  max-width: 38rem;\n}\n\n.access-check-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 0.35rem 1rem;\n}\n\n.access-scope {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.5rem;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid #eef1f5;\n}\n\n.access-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  font-size: 0.875rem;\n  color: $ink;\n  cursor: pointer;\n  line-height: 1.3;\n\n  input {\n    width: 1rem;\n    height: 1rem;\n    margin: 0;\n    flex: 0 0 auto;\n    accent-color: $active;\n  }\n\n  &--form {\n    font-weight: 600;\n  }\n}\n\n/* —— Form grant matrix (compact) —— */\n\n.access-grants {\n  display: flex;\n  flex-direction: column;\n  margin-top: 0.25rem;\n  padding: 0.15rem 0.55rem;\n  border: 1px solid #eef1f5;\n  border-radius: 6px;\n  background: #fafbfc;\n}\n\n.access-chip-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.access-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.3rem;\n  margin: 0;\n  min-width: 6.25rem;\n  padding: 0.25rem 0.5rem 0.25rem 0.35rem;\n  border: 1px solid $line;\n  border-radius: 4px;\n  background: $surface;\n  font-size: 0.78rem;\n  line-height: 1.2;\n  color: $ink;\n  cursor: pointer;\n  white-space: nowrap;\n\n  input {\n    width: 0.85rem;\n    height: 0.85rem;\n    margin: 0;\n    flex: 0 0 auto;\n    accent-color: $active;\n  }\n\n  &:hover {\n    border-color: #b8c5d4;\n  }\n\n  &--on {\n    border-color: rgba(0, 55, 112, 0.35);\n    background: rgba(0, 55, 112, 0.06);\n    font-weight: 600;\n  }\n\n  &--locked {\n    opacity: 0.72;\n    cursor: default;\n\n    input {\n      cursor: default;\n    }\n  }\n}\n\n.access-scope-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 1rem;\n  min-height: 2.15rem;\n  padding: 0.4rem 0;\n  border-top: 1px solid #eef1f5;\n\n  &:first-child {\n    border-top: none;\n    padding-top: 0.2rem;\n  }\n\n  &:last-child {\n    padding-bottom: 0.2rem;\n  }\n}\n\n.access-scope-row__title {\n  min-width: 0;\n  font-size: 0.8rem;\n  font-weight: 700;\n  line-height: 1.3;\n  color: $ink;\n}\n\n.access-scope-row__scopes {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.35rem;\n  flex: 0 0 auto;\n}\n\n.access-forms {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.access-form {\n  padding: 0.4rem 0;\n  border-bottom: 1px solid #eef1f5;\n\n  &:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n\n  .access-grants {\n    margin-top: 0.4rem;\n  }\n}\n\n.access-empty {\n  margin: 2rem 0 0;\n  text-align: center;\n  color: $muted;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 720px) {\n  .access-page {\n    padding: 1rem 0.85rem 2rem;\n  }\n\n  .access-layout {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .access-aside__list {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .access-role {\n    width: auto;\n  }\n}\n","/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
